import moment from "moment";
import { useState, useEffect, useRef } from "react";
import { myTasksSDCA5WayListName } from "src/api/config/myTasks5Way.config";
import { myTasksSDCAListName } from "src/api/config/myTasksLists.config";
import Button from "src/components/Button";
import LoadingOpBg from "src/components/LoadingOpBg";
import Select from "src/components/ui/form/select";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { clearItems, getItems } from "src/modules/spItems/actions";
import { addItemRequest, deleteItemRequest, updateItemRequest } from "src/modules/spItems/api";
import { selectGetStatus, selectItems } from "src/modules/spItems/selectors";
import AddActionInComponent from "src/pages/DashboardPage/mytasks/addAction/inComponent";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import InfoIconSdca from "../infoIconSdca";
import { FiveWhyType } from "src/api/config/systemSwitch";

const SDCA = ({
    card5WayID,
    viewMode,
    type5Way,
    card5WayTree,
    isMobileView = false,
    mobileModalZIndex,

}: {
    card5WayID: number
    viewMode: boolean
    type5Way?: string
    card5WayTree: any
    isMobileView?: boolean
    mobileModalZIndex?: number
}) => {
    const dispatch = useAppDispatch();
    const [getSDCA, setGetSDCA] = useState(false);
    const sdcaItems5Way: any = useAppSelector(state => selectItems(state, myTasksSDCA5WayListName));
    const statusItems5Way: any = useAppSelector((state) => selectGetStatus(state, myTasksSDCA5WayListName));
    const sdcaItems: any = useAppSelector(state => selectItems(state, myTasksSDCAListName));
    const [dataItems, setDataItems] = useState<any>([]);
    const [sdcaItemsNoCheked, setSdcaItemsNoChecked] = useState<any>({});
    const [rootTreeItems, setRootTreeItems] = useState<any>([]);

    useEffect(() => {
        return () => {
            dispatch(clearItems({ listName: myTasksSDCA5WayListName }));
        }
    }, []);

    useEffect(() => {
        if (card5WayID) {
            dispatch(getItems({ listName: myTasksSDCA5WayListName, filters: { _x0035_Way: card5WayID } }));
        }
    }, [card5WayID, getSDCA]);

    useEffect(() => {
        if (sdcaItems5Way.length > 0) {
            const tempItemsSdca: any = sdcaItems5Way.map((sdcaItem5Way: any) => {
                return {
                    ID: sdcaItem5Way.ID,
                    SDCA: { id: sdcaItem5Way.SDCA.ID, name: sdcaItem5Way.SDCA.Title },
                    RootTree: card5WayTree.some((treeItem: any) => treeItem.root || treeItem.system) && card5WayTree.filter((treeItem: any) => treeItem.root || treeItem.system).map((rootItem: any, idx: number) => {
                        return {
                            id: idx + 1,
                            name: rootItem.reason
                        }
                    }).find((rootItem: any) => sdcaItem5Way.RootTree && rootItem.name.trim() === sdcaItem5Way.RootTree.trim()) || null,
                    _x0035_Way: sdcaItem5Way._x0035_Way.ID
                }
            });
            setDataItems([...tempItemsSdca]);
        }
    }, [sdcaItems5Way, card5WayTree]);

    useEffect(() => {
        const strCheckdItemsObj: any = {};
        dataItems.forEach((item: any) => {
            if (item.RootTree) {
                if (!Array.isArray(strCheckdItemsObj[`"${item.RootTree.name.trim()}"`])) {
                    strCheckdItemsObj[`"${item.RootTree.name.trim()}"`] = []
                }
                strCheckdItemsObj[`"${item.RootTree.name.trim()}"`] = [...strCheckdItemsObj[`"${item.RootTree.name.trim()}"`], item];
            }
        });
        const tempObj: any = {}
        dataItems.forEach((item: any) => {
            if (item.RootTree) {
                const strCheckdItems = strCheckdItemsObj[`"${item.RootTree.name.trim()}"`].map((sdcaItem5Way: any) => sdcaItem5Way.SDCA.id).join(",");
                tempObj[`"${item.RootTree.name.trim()}"`] = sdcaItems.filter((sdcaItem: any) => strCheckdItems.indexOf(sdcaItem.ID) === -1).map((sdcaItem: any) => {
                    return {
                        id: sdcaItem.ID,
                        name: sdcaItem.Title
                    }
                })
            }
        });
        setSdcaItemsNoChecked({ ...tempObj });
    }, [sdcaItems, dataItems]);

    const addSdcaHandle = (card5WayID: number) => {
        addItemRequest({
            listName: myTasksSDCA5WayListName, body: {
                Title: `SDCA #${Math.floor(Math.random() * 1000)}`,
                SDCA: Object.keys(sdcaItemsNoCheked).length > 0 && sdcaItemsNoCheked[`"${rootTreeItems[0]['name']}"`] && sdcaItemsNoCheked[`"${rootTreeItems[0]['name']}"`][0]['id'] || sdcaItems[0]['ID'],
                _x0035_Way: card5WayID,
                RootTree: rootTreeItems[0]['name'].trim()
            }
        }).then(() => {
            setGetSDCA(!getSDCA);
        })
    }

    const removeSdcaHandle = (ID: number) => {
        deleteItemRequest({ listName: myTasksSDCA5WayListName, ID }).then(() => {
            setDataItems((prevState: any) => prevState.filter((item: any) => item.ID !== ID));
            setGetSDCA(!getSDCA);
        })
    }

    const updateSdcaHandle = (ID: number, field: string, value: any) => {
        updateItemRequest({ listName: myTasksSDCA5WayListName, body: { ID, [field]: value } }).then(() => {
            setGetSDCA(!getSDCA);
        });
    }

    useEffect(() => {
        if (card5WayTree.some((treeItem: any) => treeItem.root)) {
            setRootTreeItems([...card5WayTree.filter((treeItem: any) => treeItem.root || treeItem.system).map((itemRoot: any, idx: number) => {
                return {
                    id: idx + 1,
                    name: itemRoot.reason.trim()
                }
            })])
        }
    }, [JSON.stringify(card5WayTree)])

    return (
        <FlexCol className="mb-5 w-full gap-[10px] relative">
            {statusItems5Way === 'LOADING' && <LoadingOpBg customWrapperClass="" />}
            <FlexRow className="gap-2 items-center hidden sm:flex">
                <h3 className='text-[#637381] font-medium'>SDCA</h3>
                <InfoIconSdca />
            </FlexRow>
            {dataItems.length > 0 &&
                <>
                    {dataItems.map((item: any) => (
                        <FlexRow className="gap-2">
                            <FlexCol className="p-[20px] bg-[#F3F4F6] rounded-md gap-[20px] w-full">
                                {type5Way === FiveWhyType &&
                                    <Select dataField={{
                                        width: 'w-full',
                                        disabled: viewMode,
                                        require: false,
                                        title: 'SDCA Инструмент',
                                        type: 'select',
                                        key: 'SDCA',
                                        options: rootTreeItems.length > 0 && Object.keys(sdcaItemsNoCheked).length > 0 && sdcaItemsNoCheked[`"${rootTreeItems[0]['name']}"`] || [{ id: 0, name: 'Нет вариантов', available: false }]
                                    }} onChange={(value) => updateSdcaHandle(item.ID, 'SDCA', value.id)} value={item.SDCA} />
                                    ||
                                    <FlexRow className="gap-[20px]">
                                        <Select dataField={{
                                            width: 'w-[calc(50%-10px)]',
                                            disabled: viewMode,
                                            require: false,
                                            title: 'Корневая причина',
                                            type: 'select',
                                            key: 'RootTree',
                                            options: rootTreeItems
                                        }} onChange={(value) => updateSdcaHandle(item.ID, 'RootTree', value.name.trim())} value={item.RootTree} />
                                        <Select dataField={{
                                            width: 'w-[calc(50%-10px)]',
                                            disabled: viewMode,
                                            require: false,
                                            title: 'SDCA Инструмент',
                                            type: 'select',
                                            key: 'SDCA',
                                            options: item.RootTree && Object.keys(sdcaItemsNoCheked).length > 0 && sdcaItemsNoCheked[`"${item.RootTree['name'].trim()}"`] || [{ id: 0, name: 'Нет вариантов', available: false }]
                                        }} onChange={(value) => updateSdcaHandle(item.ID, 'SDCA', value.id)} value={item.SDCA} />
                                    </FlexRow>
                                }
                                <FlexRow className="gap-2 items-center tablet:flex">
                                    <h3 className='text-[#637381] font-medium'>Действия</h3>
                                </FlexRow>
                                <AddActionInComponent
                                    viewMode={viewMode}
                                    typeModule={type5Way === FiveWhyType && "5Почему" || "Отчет_об_отклонениях"}
                                    idModule={item.ID}
                                    CustomStyles="bg-white p-[20px]"
                                    mobileModalMode={isMobileView}
                                    mobileModalZIndex={mobileModalZIndex}
                                />
                            </FlexCol>
                            {!viewMode &&
                                <Button style={{ padding: ".75rem 0px", width: "46px" }} customFunction={removeSdcaHandle} paramsCustomFunction={item.ID} classBg="btn-white self-start justify-center hidden tablet:flex" icon={true} typeIcon="remove" text="" />
                            }
                        </FlexRow>
                    ))}
                </>
            }
            {!viewMode && card5WayTree.some((treeItem: any) => treeItem.root || treeItem.system) &&
                <Button customFunction={addSdcaHandle} paramsCustomFunction={card5WayID} classBg="btn-white w-full justify-center" icon={true} typeIcon="add" text="Добавить SDCA Инструмент" />
            }
            {card5WayTree.filter((treeItem: any) => treeItem.root || treeItem.system).length === 0 &&
                <FlexRow className="justify-center w-full rounded-md bg-[#FEF3C7] border border-[#F2A900] p-2.5">
                    <>После установления корневой причины выберите SDCA инструмент</>
                </FlexRow>
            }
        </FlexCol>
    );
};

export default SDCA;
